import React, { useCallback, useState, lazy, Suspense } from 'react';
import {
  Button,
  TextInput,
  NumberInput,
  Select,
  SelectItem,
  Checkbox,
  DataTable,
  TableRow,
  TableHead,
  TableHeader,
  TableContainer,
  TableCell,
  Table,
  TableBody,
  TableToolbar,
  TableToolbarContent,
} from 'carbon-components-react';

import Collapsible from 'react-collapsible';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { Tooltip as ReactTooltip } from "react-tooltip";


import { safeLoad, getDivHeight, jsonToYaml, updateStyle, updateStyle2, validateField, toggleDescription } from '../../helpers';

const AuthorizationrulesDeleteModal = lazy(() => import('./authorizationrulesDeleteModal'));
const AuthorizationrulesAdd = lazy(() => import('./authorizationrulesAdd'));
const AuthorizationrulesEdit = lazy(() => import('./authorizationrulesEdit'));


const handleChange = () =>{
    var yamlText = window.iagyaml;

    var json = {};

    if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
    }

    var newElem = {};
    newElem["rules"] = authorization_rulesrowData.authorization_rules;
    json["authorization"] = newElem;

    var yamlop = jsonToYaml(json);
    window.iagyaml = yamlop;
};

  const closeAdd = (idPrefix) => {

      if(idPrefix === undefined) idPrefix = "";

      updateStyle("authorization_div" + idPrefix, "display", "block");
      document.getElementById("authorization_tab" + idPrefix).style.display = "flex";

  };

const authorization_rulesheaderData = [
    {
    header: 'Name',
    key: 'name',
  },
{
    header: 'Rule',
    key: 'rule',
  },

];

const authorization_rulesrowData = {authorization_rules: []};

const authorization_ruleshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("authorization_rules_name_id" + idPrefix).value = "";
    document.getElementById("authorization_rules_rule_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("authorization_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addauthorization_rulesPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("authorization_tab" + idPrefix).style.display = "none";

  };


const AuthorizationPage = () => {

  const idPrefix = "";

  if(window.iagpage != "AuthorizationPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "AuthorizationPage";
  }

    const [authorization_rules, setauthorization_rules] = React.useState([]);
    const [fetchedauthorization_rules, setFetchedauthorization_rules] = React.useState(false);

    React.useEffect(() => {
      authorization_rulesloadGrid();
    }, [fetchedauthorization_rules]);

    const authorization_rulesloadGrid = React.useCallback(async (authorization_rules_name, authorization_rules_rule, add) => {
      try {
        var attrs = [];
        if(authorization_rules_name || authorization_rules_rule) {
          if(add) {
            for(var i = 0; i < authorization_rulesrowData.authorization_rules.length; i++) {
              var tempId = ((authorization_rulesrowData.authorization_rules[i].name)?authorization_rulesrowData.authorization_rules[i].name:"") + ((authorization_rulesrowData.authorization_rules[i].rule)?authorization_rulesrowData.authorization_rules[i].rule:"") + "";
              if((window.authorization_rulesediting != true && window.authorization_rulesediting != "true") || tempId != window.authorization_rulesrowId) {
                attrs.push(authorization_rulesrowData.authorization_rules[i]);
              }
            }
            var newId = ((authorization_rules_name)?authorization_rules_name:"") + ((authorization_rules_rule)?authorization_rules_rule:"") + "";
            attrs.push({
              id: newId,
              name: authorization_rules_name,
rule: authorization_rules_rule,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < authorization_rulesrowData.authorization_rules.length; i++) {
              if(authorization_rulesrowData.authorization_rules[i].name !== authorization_rules_name  && authorization_rulesrowData.authorization_rules[i].rule !== authorization_rules_rule ) {
                attrs.push(authorization_rulesrowData.authorization_rules[i]);
              }
            }
          }
        } else {
          attrs = authorization_rulesrowData.authorization_rules;
        }
        authorization_rulesrowData.authorization_rules = attrs;
        const data = {authorization_rules: attrs};
        setauthorization_rules(data.authorization_rules);

        if(authorization_rules_name !== undefined && authorization_rules_name !== null  && authorization_rules_rule !== undefined && authorization_rules_rule !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });



    const [authorization_rules_name, setauthorization_rules_name] = useState(''),
    updateauthorization_rules_name = useCallback((evt) => {
      setauthorization_rules_name(evt.target.value);
      var ruleWdgt = document.getElementById("authorization_rules_rule_id" + idPrefix);
      var ruleVal = (ruleWdgt)?ruleWdgt.value:"";
      var tempId = evt.target.value + ruleVal;
      validateField(authorization_rulesrowData.authorization_rules, setauthorization_rules_rule_valid, setauthorization_rules_rule_invalid_text, "Authorization Rules", "unique values", tempId);
      validateField(authorization_rulesrowData.authorization_rules, setauthorization_rules_name_valid, setauthorization_rules_name_invalid_text, "Authorization Rules", "unique values", tempId);
    }, []);

    const [authorization_rules_name_valid, setauthorization_rules_name_valid] = useState(true);
    const [authorization_rules_name_invalid_text, setauthorization_rules_name_invalid_text] = useState("");


    const [authorization_rules_rule, setauthorization_rules_rule] = useState(''),
    updateauthorization_rules_rule = useCallback((evt) => {
      setauthorization_rules_rule(evt.target.value);
      var nameWdgt = document.getElementById("authorization_rules_name_id" + idPrefix);
      var nameVal = (nameWdgt)?nameWdgt.value:"";
      var tempId = nameVal + evt.target.value;
      validateField(authorization_rulesrowData.authorization_rules, setauthorization_rules_name_valid, setauthorization_rules_name_invalid_text, "Authorization Rules", "unique values", tempId);
      validateField(authorization_rulesrowData.authorization_rules, setauthorization_rules_rule_valid, setauthorization_rules_rule_invalid_text, "Authorization Rules", "unique values", tempId);
    }, []);

    const [authorization_rules_rule_valid, setauthorization_rules_rule_valid] = useState(true);
    const [authorization_rules_rule_invalid_text, setauthorization_rules_rule_invalid_text] = useState("");



  if(window.iagpage != "AuthorizationPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "AuthorizationPage";
  }

    const [fetcheddata, setFetcheddata] = React.useState(false);
    React.useEffect(() => {
      dataLoad();
    }, [fetcheddata]);
    const dataLoad = () => {
      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

      for(var i = 0; i < authorization_rulesrowData.authorization_rules.length; i++) {
        if(authorization_rulesrowData.authorization_rules[i].id === window.authorization_rulesrowId) {
        setauthorization_rules_name((authorization_rulesrowData.authorization_rules[i] !== undefined && authorization_rulesrowData.authorization_rules[i].name !== undefined )?authorization_rulesrowData.authorization_rules[i].name:"");
        setauthorization_rules_rule((authorization_rulesrowData.authorization_rules[i] !== undefined && authorization_rulesrowData.authorization_rules[i].rule !== undefined )?authorization_rulesrowData.authorization_rules[i].rule:"");
        }
      }


      return true;
    };
    const [fetchedauthorization, setFetchedauthorization] = React.useState(false);
    React.useEffect(() => {
      getauthorization();
    }, [fetchedauthorization]);

    const getauthorization = () => {

      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

            authorization_rulesrowData.authorization_rules = [];

        if(json !== undefined && json.authorization !== undefined ) {
          if(json !== undefined && json.authorization !== undefined && json.authorization.rules !== undefined ) {
            var newruless = [];
            for(var i = 0; i < json.authorization.rules.length; i++) {
              var newItem = {};
              var tempId = ((json.authorization.rules[i].name)?json.authorization.rules[i].name:"") + ((json.authorization.rules[i].rule)?json.authorization.rules[i].rule:"");
              newItem["id"] = tempId;
              newItem["name"] = json.authorization.rules[i].name;
              newItem["rule"] = json.authorization.rules[i].rule;
              authorization_rulesrowData.authorization_rules.push(newItem);
            }
            }
        }
    };



    const setDataMain = (functionName, data) => {
      if(functionName && data) {
        eval(functionName)(data);
      }
    };

    return (
        <div className="bx--grid--no-gutter bx--grid--full-width landing-page">
          <div className="bx--row landing-page__banner" style={{paddingBottom:"3rem"}}>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h1 className="landing-page__heading">
                Authorization
              </h1>
            </div>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h4 className="landing-page__desc" style={{marginTop:"30px"}}>The `authorization` node defines the authorization rules.
</h4>
            </div>            <div id="warning_div" className="bx--col-lg-13" style={{display:'none', color:'red', position:'absolute', bottom:'0', marginBottom: '10px'}}></div>
          </div>
          <div className="bx--row landing-page__r2">
            <div className="bx--col bx--no-gutter">
              <div id="authorizationPage" className="bx--col">
                <br/><br/><br/>
            <Tabs id={"authorization_tab" + idPrefix} defaultTab={"rules_tab" + idPrefix} vertical className="vertical-tabs" style={{overflow:'auto'}}>
              <TabList>
                <Tab tabFor={"rules_tab" + idPrefix}>Rules</Tab>
              </TabList>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"rules_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading authorization_div" + idPrefix}>
                  <span className="iag_breadcrumb">Authorization : </span><br/>                  <h2>Rules Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div authorization_div" + idPrefix}>
                <div className= {"iag_form_elem authorization_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"authorization_rules_tooltip_id" + idPrefix} >Rules</h3><hr/>
</div>
          <ReactTooltip id={"authorization_rules_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" class="tooltipScroll" delayHide={500}><div style={{ maxWidth: '50vw', maxHeight: 300, overflowY: 'scroll' }}>The gateway can apply authorization rules to incoming requests. These rules can be either:<br/>  * Defined directly in a policies:authorization entry.<br/>  * Defined here in the authorization section and reference by name in a policies:authorization entry.<br/><br/>This entry defines authorization rules which can be referred to by name in a policies/authorization entry.<br/><br/>This entry is an array and can be used to specify multiple rules.<br/><br/><h4> Rule Format</h4><br/><br/>Authorization rules are composed of credential attributes and the following operators:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>Name </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Values</th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>logical operators </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> and, or, not</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>multi-valued operators </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> any, all</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>relational operators </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> =, !=, matches, &gt;, &gt;=, &lt;, &lt;=, exists</td></tr></tbody></table><br/>Parenthesis can be used for controlling the order of evaluation.<br/><br/>Examples:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>Rule </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Description</th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>(any groupIds = "administrator") </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Match when the user is in the administrator group.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>(all authenticationLevels &gt;= "2") </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Match when all credential authenticationLevels are at least level 2.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>(attribute_a matches "a(?:bc)*") </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Match when the value of the credential attribute "attribute_a" matches the regular expression.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>(level &gt;= "2") and (any groupIds = "forbidden") </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Match when the credential attribute "level" is at least level 2 and the user is in the forbidden group.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>(not exists attribute_c) </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Match when the credential does not have an attribute named "attribute_c".</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>(AZN_CRED_PRINCIPAL_NAME = "user_a") </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Match when the credential attribute "AZN_CRED_PRINCIPAL_NAME" is equal to "user_a".</td></tr></tbody></table></div></ReactTooltip>

                <div id={"authorization_rulesTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem authorization_div" + idPrefix}>
                    <DataTable id={"authorization_rulesTable" + idPrefix} isSortable
                        headers={authorization_rulesheaderData}
                        rows={authorization_rulesrowData.authorization_rules}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {authorization_ruleshandleAdd(idPrefix, [setauthorization_rules_name(''),    setauthorization_rules_name_valid(true),    setauthorization_rules_rule(''),    setauthorization_rules_rule_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <AuthorizationrulesDeleteModal row={row} loadGrid={authorization_rulesloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <AuthorizationrulesEdit  data={authorization_rulesrowData.authorization_rules} setData={setDataMain} row={row} loadGrid={authorization_rulesloadGrid} dataLoad={dataLoad} editing={true} name={"authorization_rules"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateauthorization_rules_name={updateauthorization_rules_name} authorization_rules_name={authorization_rules_name}
            authorization_rules_name_valid={authorization_rules_name_valid}
            authorization_rules_name_invalid_text={authorization_rules_name_invalid_text}
            updateauthorization_rules_rule={updateauthorization_rules_rule} authorization_rules_rule={authorization_rules_rule}
            authorization_rules_rule_valid={authorization_rules_rule_valid}
            authorization_rules_rule_invalid_text={authorization_rules_rule_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
            </Tabs>
                  <Suspense fallback={<div></div>}>
                    <AuthorizationrulesAdd loadGrid={authorization_rulesloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateauthorization_rules_name={updateauthorization_rules_name} authorization_rules_name={authorization_rules_name}
            authorization_rules_name_valid={authorization_rules_name_valid}
            authorization_rules_name_invalid_text={authorization_rules_name_invalid_text}
            updateauthorization_rules_rule={updateauthorization_rules_rule} authorization_rules_rule={authorization_rules_rule}
            authorization_rules_rule_valid={authorization_rules_rule_valid}
            authorization_rules_rule_invalid_text={authorization_rules_rule_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <AuthorizationrulesEdit  loadGrid={authorization_rulesloadGrid} dataLoad={dataLoad} name={"authorization_rules"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateauthorization_rules_name={updateauthorization_rules_name} authorization_rules_name={authorization_rules_name}
            authorization_rules_name_valid={authorization_rules_name_valid}
            authorization_rules_name_invalid_text={authorization_rules_name_invalid_text}
            updateauthorization_rules_rule={updateauthorization_rules_rule} authorization_rules_rule={authorization_rules_rule}
            authorization_rules_rule_valid={authorization_rules_rule_valid}
            authorization_rules_rule_invalid_text={authorization_rules_rule_invalid_text}
                    />
                  </Suspense>
              </div>
            </div>
          </div>
        </div>
    );
};
export default AuthorizationPage;
